import { useState } from 'react';
import { useNotification } from './use-notification';

export function useRequest() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { errorNotification } = useNotification();

  const action = async (func: () => Promise<void>) => {
    try {
      setIsLoading(true);

      await func();
    } catch (e) {
      errorNotification((e as any).response?.data?.error || (e as any).message);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    action,
  };
}
